export default "__VITE_ASSET__DWjcOh9V__"